import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';


import ShowPassword from '../assets/images/show-password.svg';

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  render() {
    return (
      <Form.Group>
        <Form.Label htmlFor={this.props.id}>{this.props.label}</Form.Label>
        <div className='passwordinput-wrap'>
          <Form.Control type={this.state.show ? 'text' : 'password'} {...this.props} />
          <Button
            tabIndex="-1"
            variant="pass"
            onClick={() => this.setState({ show: !this.state.show })}
          >
            <img src={ShowPassword} alt="#" />
          </Button>
        </div>
      </Form.Group>
    );
  }
}

PasswordInput.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default PasswordInput;
